// @flow
import React, { useState, } from 'react';
import { FelaComponent, } from 'react-fela';
import { parseStyleProps, } from '@haaretz/htz-css-tools';

import type { Node, } from 'react';
import type { StyleProps, } from '@haaretz/htz-css-tools';

type Props = {
  activeTab: number,
  render: ?string,
  miscStyles: ?StyleProps,
  children: ({
    activeTab: number,
    setActiveTab: number => void,
  }) => Node,
};

Tabs.defaultProps = {
  render: null,
  miscStyles: null,
};

function Tabs({ render, miscStyles, children, activeTab, }: Props): Node {
  const [ tab, setTab, ] = useState(activeTab);

  const setActiveTab: number => void = tabIndex => setTab(tabIndex);

  const TabTag: string = render || 'div';
  return miscStyles ? (
    <FelaComponent
      style={({ theme, }) => ({
        extend: [ ...(miscStyles ? parseStyleProps(miscStyles, theme.mq, theme.type) : []), ],
      })}
    >
      {({ className, }) => (
        <TabTag className={className}>
          {children({ activeTab: tab, setActiveTab, })}
        </TabTag>
      )}
    </FelaComponent>
  ) : (
    children({ activeTab: tab, setActiveTab, })
  );
}

export default Tabs;
